import { render, staticRenderFns } from "./InquiryTalentModal.vue?vue&type=template&id=379a6359&scoped=true"
import script from "./InquiryTalentModal.vue?vue&type=script&lang=js"
export * from "./InquiryTalentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a6359",
  null
  
)

export default component.exports